import request from '@/utils/request'

export function list(params) {
    return request({
      url: 'hslm/mall/list',
      method: 'get',
      params: params,
    })
}

/**
 * 设置店铺
 */
export function shop_set(params){
  return request({
    url: 'hslm/mall/shop_set',
    method: 'get',
    params: params
  })
}


/**
 * 设置店铺
 */
export function shop_get(params){
  return request({
    url: 'hslm/mall/shop_get',
    method: 'get',
    params: params
  })
}

//获取下载中心列表
export function list_export(params){
  return request({
      url: 'admin/Ossfile/list',
      method: 'get',
      params: params
    })
}

